import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "assignment-data-linker" }
const _hoisted_2 = {
  key: 0,
  class: "step step-notice"
}
const _hoisted_3 = {
  key: 1,
  class: "step step-form"
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = ["onUpdate:modelValue", "placeholder", "onKeydown"]
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = { class: "field" }
const _hoisted_12 = {
  key: 0,
  class: "selected-files"
}
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = { class: "step-actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "step step-review"
}
const _hoisted_17 = { class: "review-field" }
const _hoisted_18 = { class: "review-value" }
const _hoisted_19 = {
  key: 0,
  class: "review-field"
}
const _hoisted_20 = { class: "review-value" }
const _hoisted_21 = { class: "review-field" }
const _hoisted_22 = { class: "review-value" }
const _hoisted_23 = { class: "review-field review-field--block" }
const _hoisted_24 = { class: "review-text" }
const _hoisted_25 = { class: "review-field review-field--block" }
const _hoisted_26 = { class: "review-list" }
const _hoisted_27 = {
  key: 1,
  class: "review-field"
}
const _hoisted_28 = { class: "review-value" }
const _hoisted_29 = {
  key: 2,
  class: "error-message"
}
const _hoisted_30 = { class: "step-actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

import { ref } from "vue";
import { apiUrl } from "@/config/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssignmentDataLinker',
  props: {
    learningUnitId: {},
    existingAssignmentId: {},
    existingData: {}
  },
  emits: ["confirmed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const step = ref<1 | 2 | 3>(props.existingData ? 3 : 1);
const draftAssignmentId = ref<number | null>(
  props.existingAssignmentId ?? null,
);
const uploadedImageUrls = ref<string[]>(props.existingData?.kuvat ?? []);

const form = ref({
  otsikko: props.existingData?.otsikko ?? "",
  alaotsikko: props.existingData?.alaotsikko ?? "",
  lukukausi: props.existingData?.lukukausi ?? "kevät2026",
  tehtavananto: props.existingData?.tehtävänanto ?? "",
  arviointiperusteet: props.existingData?.arviointiperusteet.length
    ? [...props.existingData.arviointiperusteet]
    : [""],
});

const selectedFiles = ref<File[]>([]);
const fileInput = ref<HTMLInputElement | null>(null);

const isSaving = ref(false);
const isConfirming = ref(false);
const formError = ref("");
const confirmError = ref("");

const addCriterion = () => {
  form.value.arviointiperusteet.push("");
};

const removeCriterion = (index: number) => {
  form.value.arviointiperusteet.splice(index, 1);
};

const onFilesSelected = (event: Event) => {
  const input = event.target as HTMLInputElement;
  selectedFiles.value = input.files ? Array.from(input.files) : [];
};

const validateForm = (): boolean => {
  if (!form.value.otsikko.trim()) {
    formError.value = "Otsikko on pakollinen.";
    return false;
  }
  if (!form.value.lukukausi.trim()) {
    formError.value = "Lukukausi on pakollinen.";
    return false;
  }
  if (!form.value.tehtavananto.trim()) {
    formError.value = "Tehtävänanto on pakollinen.";
    return false;
  }
  const filled = form.value.arviointiperusteet.filter((c) => c.trim());
  if (filled.length === 0) {
    formError.value = "Vähintään yksi arviointiperuste on pakollinen.";
    return false;
  }
  formError.value = "";
  return true;
};

const saveDraftAndAdvance = async () => {
  if (!validateForm()) return;

  isSaving.value = true;
  try {
    const criteria = form.value.arviointiperusteet.filter((c) => c.trim());

    if (draftAssignmentId.value === null) {
      // Create new assignment and link to learning unit
      const res = await fetch(apiUrl("/assignments"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          learningUnitId: props.learningUnitId,
          otsikko: form.value.otsikko.trim(),
          alaotsikko: form.value.alaotsikko.trim() || undefined,
          tehtavananto: form.value.tehtavananto.trim(),
          arviointiperusteet: criteria,
          lukukausi: form.value.lukukausi.trim(),
        }),
      });
      if (!res.ok) {
        const err = (await res.json()) as { error?: string };
        throw new Error(err.error || "Virhe luotaessa tehtävää");
      }
      const data = (await res.json()) as { assignment: { id: number } };
      draftAssignmentId.value = data.assignment.id;
    } else {
      // Update existing draft
      const res = await fetch(
        apiUrl(`/assignments/${draftAssignmentId.value}`),
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            otsikko: form.value.otsikko.trim(),
            alaotsikko: form.value.alaotsikko.trim() || null,
            tehtavananto: form.value.tehtavananto.trim(),
            arviointiperusteet: criteria,
            lukukausi: form.value.lukukausi.trim(),
          }),
        },
      );
      if (!res.ok) {
        const err = (await res.json()) as { error?: string };
        throw new Error(err.error || "Virhe tallennettaessa tehtävää");
      }
    }

    // Upload images if any were selected
    if (selectedFiles.value.length > 0) {
      const formData = new FormData();
      selectedFiles.value.forEach((file) => formData.append("images", file));

      const imgRes = await fetch(
        apiUrl(`/assignments/${draftAssignmentId.value}/images`),
        {
          method: "POST",
          credentials: "include",
          body: formData,
        },
      );
      if (!imgRes.ok) {
        let errMsg: string | undefined;
        const contentType = imgRes.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          const err = (await imgRes.json()) as { error?: string };
          errMsg = err.error;
        }
        if (!errMsg) {
          errMsg =
            imgRes.status === 413
              ? "Kuvat ovat liian suuria. Pienennä kuvia tai lataa vähemmän kerralla."
              : "Virhe kuvien lataamisessa";
        }
        throw new Error(errMsg);
      }
      const imgData = (await imgRes.json()) as { urls: string[] };
      uploadedImageUrls.value = [...uploadedImageUrls.value, ...imgData.urls];
      selectedFiles.value = [];
      if (fileInput.value) fileInput.value.value = "";
    }

    step.value = 3;
  } catch (error) {
    formError.value =
      error instanceof Error ? error.message : "Tuntematon virhe";
  } finally {
    isSaving.value = false;
  }
};

const confirmAssignment = async () => {
  if (draftAssignmentId.value === null) return;

  isConfirming.value = true;
  confirmError.value = "";

  try {
    const res = await fetch(
      apiUrl(`/assignments/${draftAssignmentId.value}/confirm`),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      },
    );
    if (!res.ok) {
      const err = (await res.json()) as { error?: string };
      throw new Error(err.error || "Virhe vahvistettaessa tehtävää");
    }

    const criteria = form.value.arviointiperusteet.filter((c) => c.trim());
    emit("confirmed", {
      id: draftAssignmentId.value,
      isConfirmed: true,
      tehtävänanto: form.value.tehtavananto.trim(),
      arviointiperusteet: criteria,
      kuvat: uploadedImageUrls.value,
      peerGalleryDriveLink: null,
    });
  } catch (error) {
    confirmError.value =
      error instanceof Error ? error.message : "Tuntematon virhe";
  } finally {
    isConfirming.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (step.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "notice-icon" }, "⚠️", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Tehtävätiedot puuttuvat", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", null, " Tälle tehtävälle ei ole vielä linkitetty tietoja. Hae tehtävän tiedot koulun intranetistä ja syötä ne lomakkeeseen. ", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("a", {
            href: "https://sites.google.com/teho-opisto.fi/intranet/opetusmateriaali/kotitehtävät",
            target: "_blank",
            rel: "noopener noreferrer",
            class: "intranet-link"
          }, " Avaa intranet → ", -1)),
          _createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value = 2))
          }, "Syötä tiedot")
        ]))
      : (step.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Tehtävän tiedot", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "otsikko" }, [
                _createTextVNode("Otsikko "),
                _createElementVNode("span", { class: "required" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "otsikko",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.otsikko) = $event)),
                type: "text",
                placeholder: "esim. Tehtävä 3 — Tarinakirjoitus",
                class: "text-input"
              }, null, 512), [
                [_vModelText, form.value.otsikko]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "alaotsikko" }, "Alaotsikko", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "alaotsikko",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.alaotsikko) = $event)),
                type: "text",
                placeholder: "Valinnainen tarkentava otsikko",
                class: "text-input"
              }, null, 512), [
                [_vModelText, form.value.alaotsikko]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "lukukausi" }, [
                _createTextVNode("Lukukausi "),
                _createElementVNode("span", { class: "required" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "lukukausi",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.lukukausi) = $event)),
                type: "text",
                placeholder: "esim. kevät2026",
                class: "text-input"
              }, null, 512), [
                [_vModelText, form.value.lukukausi]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { for: "tehtavananto" }, [
                _createTextVNode("Tehtävänanto "),
                _createElementVNode("span", { class: "required" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "tehtavananto",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.tehtavananto) = $event)),
                placeholder: "Kirjoita tehtävänanto tähän...",
                class: "textarea-input",
                rows: "6"
              }, null, 512), [
                [_vModelText, form.value.tehtavananto]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, [
                _createTextVNode("Arviointiperusteet "),
                _createElementVNode("span", { class: "required" }, "*")
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.arviointiperusteet, (criterion, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "criterion-row"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((form.value.arviointiperusteet[index]) = $event),
                    type: "text",
                    placeholder: `Peruste ${index + 1}`,
                    class: "text-input criterion-input",
                    onKeydown: _withKeys(_withModifiers(addCriterion, ["prevent"]), ["enter"])
                  }, null, 40, _hoisted_9), [
                    [_vModelText, form.value.arviointiperusteet[index]]
                  ]),
                  _createElementVNode("button", {
                    class: "btn-icon btn-remove",
                    onClick: ($event: any) => (removeCriterion(index)),
                    disabled: form.value.arviointiperusteet.length <= 1,
                    title: "Poista peruste"
                  }, " × ", 8, _hoisted_10)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: "btn-secondary btn-add-criterion",
                onClick: addCriterion
              }, " + Lisää arviointiperuste ")
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "Kuvat (valinnainen)", -1)),
              _createElementVNode("input", {
                ref_key: "fileInput",
                ref: fileInput,
                type: "file",
                multiple: "",
                accept: "image/jpeg,image/png,image/gif,image/webp",
                class: "file-input-hidden",
                onChange: onFilesSelected
              }, null, 544),
              _createElementVNode("button", {
                type: "button",
                class: "btn-secondary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (fileInput.value?.click()))
              }, " Valitse kuvat... "),
              (selectedFiles.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFiles.value, (file) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: file.name,
                        class: "file-chip"
                      }, _toDisplayString(file.name), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (formError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(formError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (step.value = 1))
              }, "← Takaisin"),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: saveDraftAndAdvance,
                disabled: isSaving.value
              }, _toDisplayString(isSaving.value ? "Tallennetaan..." : "Seuraava →"), 9, _hoisted_15)
            ])
          ]))
        : (step.value === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Tarkista tiedot ennen tallentamista", -1)),
              _createElementVNode("div", _hoisted_17, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "review-label" }, "Otsikko", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(form.value.otsikko), 1)
              ]),
              (form.value.alaotsikko)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "review-label" }, "Alaotsikko", -1)),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(form.value.alaotsikko), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "review-label" }, "Lukukausi", -1)),
                _createElementVNode("span", _hoisted_22, _toDisplayString(form.value.lukukausi), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "review-label" }, "Tehtävänanto", -1)),
                _createElementVNode("pre", _hoisted_24, _toDisplayString(form.value.tehtavananto), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "review-label" }, "Arviointiperusteet", -1)),
                _createElementVNode("ol", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.arviointiperusteet, (criterion, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(criterion), 1))
                  }), 128))
                ])
              ]),
              (uploadedImageUrls.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "review-label" }, "Kuvat", -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(uploadedImageUrls.value.length) + " kuva" + _toDisplayString(uploadedImageUrls.value.length !== 1 ? "a" : "") + " ladattu", 1)
                  ]))
                : _createCommentVNode("", true),
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "immutability-warning" }, " ⚠️ Tallentamisen jälkeen tietoja ei voi muokata. ", -1)),
              (confirmError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(confirmError.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (step.value = 2)),
                  disabled: isConfirming.value
                }, " ← Takaisin ", 8, _hoisted_31),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: confirmAssignment,
                  disabled: isConfirming.value
                }, _toDisplayString(isConfirming.value ? "Tallennetaan..." : "Tallenna pysyvästi"), 9, _hoisted_32)
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})